import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';

import fontAwesome from "font-awesome/scss/font-awesome.scss";
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css";
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css";
import ScrollReveal from "scrollreveal";
import Vivus from "vivus";

class App {
    constructor() {
        this.Utils = new Utils();
        this.Accordion = new Accordion();
        this.Anchor = new Anchor();
        this.FixedHeader = new FixedHeader();
        this.HeightLine = new HeightLine();
        this.ResponsiveTable = new ResponsiveTable();
        this.Slidebar = new Slidebar();
        this.CurrentNav = new CurrentNav();
        this.Tab = new Tab();


        $(function() {
            var owls = $('.owl-carousel');
            if (owls.length === 0) {
                return false
            }
            owls.imagesLoaded(function () {
                var $topSlider =  $('.c-main-visual__slider');
                $topSlider.owlCarousel({
                    callbacks: true,
                    margin: 0,
                    dots: true,
                    loop: true,
                    nav: true,
                    autoplay: true,
                    autoplaySpeed: 1500,
                    center:true,
                    items: 1,
                    navText: ['<img src="/wp-content/themes/tsm-html/dist/assets/images/icon-slider-top-prev.png" />','<img src="/wp-content/themes/tsm-html/dist/assets/images/icon-slider-top-next.png" />']
                });

                var $newsSlider =  $('.c-top-news__slider');
                $newsSlider.owlCarousel({
                    callbacks: true,
                    margin: 0,
                    dots: false,
                    loop: true,
                    nav: true,
                    autoplayHoverPause: true,
                    autoplay: true,
                    autoplaySpeed: 1000,
                    center:true,
                    navText: ['<img src="/wp-content/themes/tsm-html/dist/assets/images/icon-slider-news-prev.png" />','<img src="/wp-content/themes/tsm-html/dist/assets/images/icon-slider-news-next.png" />'],
                    responsive: {
                        0:{
                            items: 1,
                            nav: true
                        },
                        950:{
                            items: 3,
                            nav: true
                        }
                    }
                });

                var $exampleSlider =  $('.c-top-example__slider.is-top');
                $exampleSlider.owlCarousel({
                    callbacks: true,
                    dots: true,
                    loop: true,
                    nav: true,
                    autoplayHoverPause: true,
                    autoplay: true,
                    autoplaySpeed: 1000,
                    margin: 36,
                    center: true,
                    navText: ['<img src="/wp-content/themes/tsm-html/dist/assets/images/icon-slider-news-prev.png" />','<img src="/wp-content/themes/tsm-html/dist/assets/images/icon-slider-news-next.png" />'],
                    responsive: {
                        0:{
                            items: 1,
                            nav: true,
                            dots: true
                        },
                        950:{
                            items: 4,
                            nav: true,
                            dots: true
                        }
                    }
                });
            });

        });
    }
}

window.GApp = new App();


(function ($) {

    var growApp = function () {
    };
    /*
     * userAgent取得
     * */
    var Agent = window.navigator.userAgent.toLowerCase();
    var _ua = (function (u) {
        return {
            Tablet: (u.indexOf("windows") != -1 && u.indexOf("touch") != -1 && u.indexOf("tablet pc") == -1)
                || u.indexOf("ipad") != -1
                || (u.indexOf("android") != -1 && u.indexOf("mobile") == -1)
                || (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1)
                || u.indexOf("kindle") != -1
                || u.indexOf("silk") != -1
                || u.indexOf("playbook") != -1,
            Mobile: (u.indexOf("windows") != -1 && u.indexOf("phone") != -1)
                || u.indexOf("iphone") != -1
                || u.indexOf("ipod") != -1
                || (u.indexOf("android") != -1 && u.indexOf("mobile") != -1)
                || (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1)
                || u.indexOf("blackberry") != -1
        }
    })(Agent);

    growApp.prototype.footerMenu = function () {
        var win = $(window).innerWidth();
        if (win > 750) {
            return false;
        }
        $('.c-footer-menu__block').on('click',function() {
            $(this).children(".c-footer-menu__title").toggleClass('is-open');
            $(this).children(".c-footer-menu__list.is-sub").slideToggle();
        })
    }


    growApp.prototype.buttonWrap = function () {
        var button = $(".c-button");
        button.wrapInner("<span></span>");
    }

    growApp.prototype.gellery = function () {
        $("#js-gellery img").click(function(){
            var img_src = $(this).attr("src");
            $("#js-preview").css("background-image", "url(" + img_src + ")");
            $("#js-gellery > div ").removeClass("is-active");
            $(this).parent().addClass("is-active");
        });
    }

    growApp.prototype.topOpening = function () {
        if ( $("#canvas").length ){
            new Vivus(
              'canvas',
              {
                type: "sync",
                duration: 140,
                start: 'autostart',
                reverseStack: true,
                pathTimingFunction: Vivus.EASE_OUT,
              }
            );
            if ($(window).width() < 640){
              new Vivus(
                'canvassmp',
                {
                  type: "sync",
                  duration: 100,
                  start: 'autostart',
                  reverseStack: true,
                  pathTimingFunction: Vivus.EASE_OUT,
                }
              );
            }
        }

        var $opening = $(".c-top-opening");
        $opening.addClass("is-in")
        if ( $opening.length ){
            setTimeout(function(){
                $opening.fadeOut();
            },2500);
        }

    }



    $(function () {
        var app = new growApp();
        //app.footerMenu();
        app.buttonWrap();
        app.gellery();
        app.topOpening();
    });

})(jQuery);

